/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeFileTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   File Type Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, December 02, 2018 - 05:56:06 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      12/02/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const FILETYPE_LIST_CONTAINER_LOADED = 'FILETYPE_LIST_CONTAINER_LOADED';
export const FILETYPE_LIST_CONTAINER_UNLOADED = 'FILETYPE_LIST_CONTAINER_UNLOADED';
export const FILETYPE_LIST_TABLE_LOADED = 'FILETYPE_LIST_TABLE_LOADED';
export const FILETYPE_LIST_TABLE_UNLOADED = 'FILETYPE_LIST_TABLE_UNLOADED';

export const FILETYPE_SELECT_ROW = 'FILETYPE_SELECT_ROW';

export const FILETYPE_ADD = 'FILETYPE_ADD';
export const FILETYPE_EDIT = 'FILETYPE_EDIT';
export const FILETYPE_DELETE = 'FILETYPE_DELETE';
export const FILETYPE_OPEN_WARNING = 'FILETYPE_OPEN_WARNING';
export const FILETYPE_CLOSE_WARNING = 'FILETYPE_CLOSE_WARNING';

export const FILETYPE_EDIT_CONTAINER_LOADED = 'FILETYPE_EDIT_CONTAINER_LOADED';
export const FILETYPE_EDIT_CONTAINER_UNLOADED = 'FILETYPE_EDIT_CONTAINER_UNLOADED';
export const FILETYPE_EDIT_FORM_LOADED = 'FILETYPE_EDIT_FORM_LOADED';
export const FILETYPE_EDIT_FORM_UNLOADED = 'FILETYPE_EDIT_FORM_UNLOADED';

export const FILETYPE_EDIT_DATA_LOAD = 'FILETYPE_EDIT_DATA_LOAD';

export const FILETYPE_EDIT_CONTAINER_SUBMIT = 'FILETYPE_EDIT_CONTAINER_SUBMIT';
export const FILETYPE_EDIT_CONTAINER_CANCEL = 'FILETYPE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeFileTypes.js